import React, { useState, useEffect } from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../../components/fields/TextInput/TextInputWithLabel';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import FileInput from '../../../../../components/fields/FileInput/FileInput';
import SZLTDTO from '../../../../../dto/SZLTDTO';

export default function NewSZLTForm(props) {
  const {
    prefix = 'application_order_service_new.',
    control,
    formMeta,
    applicantType,
    procedure,
    isEdit = false,
    currentApplication = {},
    setValue,
    getValues,
  } = props;

  const initShowBlock1 = isEdit
    ? !!currentApplication?.application_order_service_new?.order_receiving_methods
    || currentApplication?.application_order_service_new?.order_receiving_methods === null
    : false;
  const [showBlock1, setShowBlock1] = useState(initShowBlock1);

  const initShowBlock2 = isEdit ? !!currentApplication?.application_order_service_new?.web_site || currentApplication?.application_order_service_new?.web_site === null : false;
  const [showBlock2, setShowBlock2] = useState(initShowBlock2);

  const dto = new SZLTDTO();
  const attributes = dto.getAttributesByName();

  useEffect(() => {
    setValue(`${prefix}.order_receiving_methods`, !showBlock1 ? null : (isEdit ? getValues(`${prefix}.order_receiving_methods`) || '' : ''));
    setValue('media.order_receiving_methods_change_document', null);
  }, [showBlock1]);

  useEffect(() => {
    setValue(`${prefix}.web_site`, !showBlock1 ? null : (isEdit ? getValues(`${prefix}.web_site`) || '' : ''));
    setValue('media.web_site_change_document', null);
  }, [showBlock2]);

  if (![PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) || applicantType !== USER_TYPE.LEGAL) {
    return null;
  }

  return (
    <>
      <div className="f3 mt-3">Изменились сведения о СЗЛТ</div>

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowBlock1(!showBlock1),
              value: showBlock1,
            }}
            label="Изменились способы получения и передачи заказов ЛТ"
          />
        </Col>
      </Row>
      {showBlock1 && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.order_receiving_methods}
            variant="material"
            namePrefix={prefix}
            labelPrefix="new."
          />
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.order_receiving_methods_change_document}
              variant="material"
              namePrefix="media."
            />
          </Row>
        </Row>
      )}

      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowBlock2(!showBlock2),
              value: showBlock2,
            }}
            label="Изменился адрес сайта ИТС 'Интернет'"
          />
        </Col>
      </Row>
      {showBlock2 && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.web_site}
            variant="material"
            namePrefix={prefix}
            labelPrefix="new."
          />
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.web_site_change_document}
              variant="material"
              namePrefix="media."
            />
          </Row>
        </Row>
      )}

      <div className="hr-row mt-3" />
    </>
  );
}
